<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <div>
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'Company' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Back to company list</span>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-card
          rounded="lg"
          outlined
          :style="'border-color: ' + maincolor">
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12" md="12" v-if="alertdata.show">
                <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
              </v-col>
              <v-col cols="12" md="12" v-if="loading.getdata" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.getdata && datalist.length > 0">
                <v-row>
                  <v-col cols="12" md="8">
                    <div class="d-flex">
                      <div class="d-inline mr-5">
                        <v-img
                          :lazy-src="require('../assets/default.jpg')"
                          :src="datalist[0].urlpic ? datalist[0].urlpic : ''"
                          max-height="70"
                          max-width="70">
                        </v-img>
                      </div>
                      <div class="d-inline">
                        <h2 class="text-md-h4 font-weight-bold">
                          {{ datalist[0].com_name ? datalist[0].com_name : 'Company name' }}
                        </h2>
                        <span class="text-subtitle-1">
                          {{ datalist[0].com_field ? datalist[0].com_field : 'Company field' }}
                        </span>
                      </div>
                      <div class="d-inline">
                        <v-tooltip top v-if="datalist[0].com_mou === 'yes'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              size="28"
                              class="mt-2"
                              right
                              color="success"
                              v-bind="attrs"
                              v-on="on">
                              mdi-check-decagram
                            </v-icon>
                          </template>
                          <span>Verified as PNB Partner</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'">
                    <p class="text-subtitle-1 mb-0 font-weight-bold">
                      <v-icon class="mr-1">mdi-update</v-icon>
                      <timeago :datetime="datalist[0].com_update"></timeago>
                    </p>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-tabs
                      v-model="tabdata"
                      show-arrows>
                      <v-tabs-slider :color="maincolor"></v-tabs-slider>
                      <v-tab href="#profile" active-class="main-style-slide">
                        Profile
                      </v-tab>
                      <v-tab href="#jobs" active-class="main-style-slide">
                        <v-badge
                          color="error"
                          :content="datalist[0].jumjob">
                          Jobs
                        </v-badge>
                      </v-tab>
                    </v-tabs>
                    <v-divider></v-divider>
                    <v-tabs-items :touchless="true" v-model="tabdata">
                      <v-tab-item value="profile">
                        <v-card flat>
                          <v-card-text class="px-0">
                            <v-row class="black--text">
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Company size</span>
                                <h3 class="text-md-h6 font-weight-bold mb-3">
                                  <v-icon :color="maincolor">
                                    mdi-account-group
                                  </v-icon>
                                  {{ datalist[0].com_size ? datalist[0].com_size : '2' }} employees
                                </h3>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Location</span>
                                <h3 class="text-md-h6 font-weight-bold mb-3">
                                  <v-icon :color="maincolor">
                                    mdi-map-marker
                                  </v-icon>
                                  {{ datalist[0].com_location ? datalist[0].com_location : 'Location' }}
                                </h3>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Spesialisasi</span>
                                <h3 class="text-md-h6 font-weight-bold mb-3">
                                  <v-icon :color="maincolor">
                                    mdi-account-details-outline
                                  </v-icon>
                                  {{ datalist[0].com_field ? datalist[0].com_field : 'Company field' }}
                                </h3>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Address</span>
                                <p class="mb-3">
                                  {{ datalist[0].com_address ? datalist[0].com_address : 'Address' }}
                                </p>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Contact</span>
                                <div class="mb-3">
                                  <v-btn
                                    :href="'tel:' + datalist[0].com_phone"
                                    class="mr-2"
                                    small
                                    fab
                                    outlined>
                                    <v-icon>
                                      mdi-phone-classic
                                    </v-icon>
                                  </v-btn>
                                  <v-btn
                                    :href="'mailto:' + datalist[0].com_email"
                                    class="mr-2"
                                    small
                                    fab
                                    outlined>
                                    <v-icon>
                                      mdi-email
                                    </v-icon>
                                  </v-btn>
                                  <v-btn
                                    :href="datalist[0].com_website"
                                    target="_blank"
                                    class="mr-2"
                                    small
                                    fab
                                    outlined>
                                    <v-icon>
                                      mdi-web
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" md="12" v-show="!$vuetify.breakpoint.smAndDown">
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                            <v-row class="black--text">
                              <v-col cols="12" md="12">
                                <h3 class="text-md-h5 font-weight-bold mb-3">
                                  About {{ datalist[0].com_name ? datalist[0].com_name : 'Company name' }}
                                </h3>
                                <div
                                  class="content-editor"
                                  v-html="datalist[0].com_desc ? datalist[0].com_desc : 'Description'">
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item value="jobs">
                        <v-card flat>
                          <v-card-text class="px-0">
                            <v-row class="black--text">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="4"
                                v-for="(job, i) in joblist"
                                :key="i">
                                <job :job="job"></job>
                              </v-col>
                            </v-row>
                            <v-row class="black--text text-center">
                              <v-col cols="12" md="12">
                                <infinite-loading :identifier="infiniteId" @infinite="getJobCom">
                                  <div slot="spinner">Loading...</div>
                                  <div slot="no-more"></div>
                                  <div slot="no-results"></div>
                                </infinite-loading>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import Job from '../components/Job.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'Companydetail',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    tabdata: 'profile',
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    joblist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    comid: '',
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    paramjob: {
      com_id: '',
      keyword: '',
      limit: 20,
      offset: 0,
    },
    infiniteId: +new Date(),
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    if (this.$route.query.comid && this.$route.query.comid !== '') {
      this.comid = this.$route.query.comid;
      this.getDetailCom();
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$route.query.comid'(val) {
      if (val) {
        this.comid = val;
        this.getDetailCom();
      }
    },
  },
  methods: {
    getDetailCom() {
      this.alertdata.show = false;
      this.datalist = [];
      if (this.publickey) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/public/company/' + this.comid,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  this.datalist.push(element);
                });
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Invalid Token!';
      }
    },
    getJobFilter() {
      this.paramjob.offset = 0;
      this.joblist = [];
      this.infiniteId += 1;
    },
    getJobCom($state) {
      this.paramjob.com_id = this.comid;
      this.axios
        .get(
          this.api + '/public/jobs',
          {
            params: this.paramjob,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramjob.offset += this.paramjob.limit;
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  this.joblist.push(element);
                });
                // this.joblist.push(...resdata.data);
                if (this.joblist.length < this.paramjob.offset) {
                  if ($state !== false) {
                    $state.complete();
                  }
                } else {
                  if ($state !== false) {
                    $state.loaded();
                  }
                }
              } else {
                if ($state !== false) {
                  $state.complete();
                }
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
    Job,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
